import { doc, setDoc, addDoc, getDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../config/FirebaseConfig"; // db exported from your config

class CompanyApi {
    // '<' operator is used to filter based on less than
    // '<=' operator is used to filter based on less than or equal to
    // '==' operator is used to filter based on equal to
    // '>' operator is used to filter based on greater than
    // '>=' operator is used to filter based on greater than or equal to
    // '!=' operator is used to filter based on not equal to
    // 'array-contains' operator is used to filter based on array contains
    // 'array-contains-any' operator is used to filter based on array contains any
    // 'in' operator is used to filter based on in
    // 'not-in' operator is used to filter based on not in

    /*
    {
        name: string,
        ownerId: userId,                // Producer who owns it
        isActive: boolean,
        isDeleted: boolean,
        createdAt: timestamp,
        updatedAt: timestamp
    }

    {
        role: "producer",
        joinedAt: timestamp
    }

    companies/
    {companyId}/
        name: ""
        ownerId: ""
        ...
        members/
        {userId}/
            role: ""
            ...
    */

    async getCompany(id = null) {
        if (!id) {
            console.error("Invalid company ID:", id);
            return { success: false, error: "Invalid company ID" };
        }
        try {
            const companyDoc = await getDoc(doc(db, "companies", id));
            if (companyDoc.exists()) {
                return { success: true, company: companyDoc.data() };
            } else {
                console.error("Company not found:", id);
                return { success: false, error: "Company not found" };
            }
        } catch (error) {
            console.error("Error fetching company:", error);
            return { success: false, error: error.message };
        }
    }

    async createCompany(body = {}) {
        if (!body || !body.name || !body.ownerId) {
            console.error("Invalid company data:", body);
            return { success: false, error: "Invalid company data" };
        }
        try {
            const companyRef = await addDoc(collection(db, "companies"), {
                name: body.name,
                ownerId: body.ownerId,
                isActive: true,
                isDeleted: false,
                createdAt: serverTimestamp(),
                updatedAt: serverTimestamp(),
            });
            await this.createCompanyMember(companyRef.id, body.ownerId, "producer");

            return { success: true, companyId: companyRef.id };
        } catch (error) {
            console.error("Error creating company:", error);
            return { success: false, error: error.message };
        }
    }

    async createCompanyMember(companyId, userId, role = "producer") {
        if (!companyId || !userId) {
            console.error("Missing companyId or userId");
            return { success: false, error: "Missing companyId or userId" };
        }

        try {
            const memberRef = doc(db, "companies", companyId, "members", userId);
            await setDoc(memberRef, {
                role,
                joinedAt: serverTimestamp(),
            });

            return { success: true };
        } catch (error) {
            console.error("Error adding company member:", error);
            return { success: false, error: error.message };
        }
    }

}

export default CompanyApi;